export default __webpack_public_path__ + "static/media/pexels-christina-morillo-1181605.c365f0f3.jpg";